export function processObjectNullValues(obj, defaultValue = '-') {
    const processedObj = {};

    for (const [key, value] of Object.entries(obj)) {
        if (value === null || value === undefined || value === '' || value === 'null') {
            processedObj[key] = defaultValue;
        } else if (typeof value === 'object' && value !== null) {
            processedObj[key] = processObjectNullValues(value, defaultValue);
        } else {
            processedObj[key] = value;
        }
    }

    return processedObj;
}